<ng-template #template>
  <ng-container *ngTemplateOutlet="displayedTemplate"></ng-container>
</ng-template>

<ng-template #templateCanBeClicked>
  <a
    href="javascript:void(0)"
    class="c-next-action01 c-next-action01--note"
    id="{{ itemId }}"
    (throttleClick$)="onClick()"
    aswThrottleClick
  >
    <div class="c-next-action01__body">
      <div class="c-next-action01__title c-next-action01__title--em" [attr.aria-label]="titleAria">{{ title }}</div>
      <div class="c-next-action01__contents">
        <div class="c-next-action01__contents-item" *ngIf="textContent">
          {{ textContent }}
        </div>
        <ng-container *ngIf="hasContentList">
          <div class="c-next-action01__contents-item">
            <ng-container *ngTemplateOutlet="renderContents; context: { contentList: contentList }"></ng-container>
          </div>
        </ng-container>
        <ng-container *ngIf="hasContentAttentionList">
          <ng-container
            *ngTemplateOutlet="renderContentAttention; context: { contentAttentionList: contentAttentionList }"
          ></ng-container>
        </ng-container>
      </div>
    </div>
  </a>
</ng-template>

<ng-template #templateCantBeClicked>
  <div class="c-next-action03" [id]="itemId">
    <div class="c-next-action03__body">
      <div class="c-next-action03__title" [attr.aria-label]="titleAria">{{ title }}</div>
      <div class="c-next-action03__contents">
        <div class="c-next-action03__contents-item" *ngIf="textContent">
          {{ textContent }}
        </div>
        <ng-container *ngIf="hasContentList">
          <div class="c-next-action03__contents-item">
            <ng-container *ngTemplateOutlet="renderContents; context: { contentList: contentList }"></ng-container>
          </div>
        </ng-container>
        <ng-container *ngIf="hasContentAttentionList">
          <ng-container
            *ngTemplateOutlet="renderContentAttention; context: { contentAttentionList: contentAttentionList }"
          ></ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #renderContents let-contentList="contentList">
  <dl class="c-float-list01">
    <ng-container *ngFor="let content of contentList">
      <ng-container *ngTemplateOutlet="content.itemTemplate"></ng-container>
    </ng-container>
  </dl>
</ng-template>

<ng-template #renderContentAttention let-contentAttentionList="contentAttentionList">
  <ng-container *ngFor="let attention of contentAttentionList">
    <ng-container *ngTemplateOutlet="attention.itemTemplate"></ng-container>
  </ng-container>
</ng-template>
